import { render } from "./AccountSummaryButton.vue?vue&type=template&id=2bc6cca0&scoped=true"
import script from "./AccountSummaryButton.vue?vue&type=script&lang=js"
export * from "./AccountSummaryButton.vue?vue&type=script&lang=js"

import "./AccountSummaryButton.vue?vue&type=style&index=0&id=2bc6cca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc6cca0"]])

export default __exports__